import { getHeaders } from "./authentication";

const initialState = {
  data: null,
  error: null,
  fetching: false,
};

const PATIENTS_REPORT_PROCESSING = 'PATIENTS_REPORT_PROCESSING';
const PATIENTS_REPORT_PROCESSING_SUCCESS = 'PATIENTS_REPORT_PROCESSING_SUCCESS';
const PATIENTS_REPORT_PROCESSING_FAILURE = 'PATIENTS_REPORT_PROCESSING_FAILURE';
const PATIENTS_REPORT_PROCESSING_RESET = 'PATIENTS_REPORT_PROCESSING_RESET';

export const processPatientsReport = (organisationId, supportUserId) => ({
  types: [PATIENTS_REPORT_PROCESSING, PATIENTS_REPORT_PROCESSING_SUCCESS, PATIENTS_REPORT_PROCESSING_FAILURE],
  payload: {
    request: {
      url: `chains/patients-reports/long-polling?organisation_id=${organisationId}&user_id=${supportUserId}`,
      method: 'GET',
      headers: getHeaders(),
    },
  },
});

export const patientsReportProcessReset = () => ({
  type: PATIENTS_REPORT_PROCESSING_RESET,
});

const patientsReportProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case PATIENTS_REPORT_PROCESSING:
      return { ...state, fetching: true };
    case PATIENTS_REPORT_PROCESSING_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload.data
      };
    case PATIENTS_REPORT_PROCESSING_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error?.response?.data?.message || action.error.message,
      };
    case PATIENTS_REPORT_PROCESSING_RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default patientsReportProcessReducer;
